import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import classNames from 'classnames';
import { useForm } from 'react-hook-form';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { useDispatch, useSelector } from 'react-redux';
import {
	UpdateGarageListing,
	AddMedia,
	getCarBrand,
} from './../../../../Redux/Actions/UserAction';
export default function TaxiCars() {
	const home = useSelector(state => state?.home);
	const CarBrandList = home?.garageCarBrandList;
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getCarBrand());
	}, []);
	return (
		<div>
			<div class='sp-banner'>
				<img
					src='assets/images/service-provider/taxi/banner-a.jpg'
					alt=''
					class='img-fluid sp-banner-img'
				/>
				<div class='sp-logo'>
					<div class='line-a'>
						<img
							src='assets/images/service-provider/taxi/logo.jpg'
							alt=''
							class='img-fluid'
						/>
					</div>
					<div class='line-b'>Taxi business Name</div>
				</div>
			</div>
			n
			<div class='main-content-area'>
				<div class='container'>
					<div class='row justify-content-between'>
						<div class='col-12 col-sm-12 col-md-3 col-lg-3 mb-4 mb-sm-4 mb-md-0 mb-lg-0'>
							{/* [FB2-#20] Standalone subscription/PACKAGE box removed — the
							    taxi menu now matches the other categories; subscription is
							    accessed via "Manage Subscription" under Manage Business. */}
							<div class='side-links-wrap'>
								<ul>
									<li>
										<Link to='/sp-taxi-business' class='active'>
											<img
												src='assets/images/icons/sp-business/manage-business.svg'
												alt=''
											/>{' '}
											Manage Business
										</Link>
									</li>
									<li>
										<Link to='/sp-taxi-car-cars'>
											<img
												src='assets/images/icons/sp-business/manage-service.svg'
												alt=''
											/>{' '}
											Manage Cars
										</Link>
									</li>

									<li>
										<Link to='/sp-taxi-car-banner' class='active'>
											<img
												src='assets/images/icons/sp-business/banner.svg'
												alt=''
											/>{' '}
											Banner
										</Link>
									</li>

									<li>
										<Link to='/sp-taxi-car-working-hours'>
											<img
												src='assets/images/icons/sp-business/manage-working-hours.svg'
												alt=''
											/>{' '}
											Manage Working Hours
										</Link>
									</li>

									<li>
										<Link to='javascript:void(0);'>
											<img
												src='assets/images/icons/sp-business/visible.svg'
												alt=''
											/>{' '}
											Make me invisible
										</Link>
									</li>

									{/* 							
							<li><Link to="/sp-taxi-business"><img src="assets/images/icons/sp-business/manage-business.svg" alt=""/> Manage Profile</Link></li>
							<li><a href="javascript:void(0);"><img src="assets/images/icons/sp-business/visible.svg" alt=""/> Make me invisible</a></li>
						 */}
								</ul>
							</div>
						</div>

						<div class='col-12 col-sm-12 col-md-9 col-lg-9'>
							<h1>Cars</h1>

											<div className="row">
							{CarBrandList !== undefined && CarBrandList !== []
								? CarBrandList?.map((item, index) => {
									return (
											<div class='col-6 col-sm-6 col-md-4 col-lg-3 mb-4'>
												<div class='user-car-dealers-wrap'>
													<div class='line-a'>
														<Link to='/sp-taxi-car-post'>
														<img style={{height:'7rem',width:'100%'}}
															src={
																	item?.media?.path !== undefined
																		? item?.media?.path
																		: 'assets/images/user/taxi/user.jpg'
																}
																// src='assets/images/user/car-dealers/a.jpg'
																alt=''
																class='img-fluid'
															/>
														</Link>
													</div>
													<div class='line-b'>
														<div class='row'>
															<div class='col-7 col-lg-8'>
															<div class='line-ba'>{ item?.name}</div>
																<div class='line-bb'>Aventador</div>
															</div>
															<div class='col-5 col-lg-4'>
																<div class='row no-gutters'>
																	<div class='col-6'>
																		<Link
																			to='javascript:void(0);'
																			data-toggle='tooltip'
																			data-placement='top'
																			title='Save'
																			class='ss-btn'>
																			<i class='far fa-heart'></i>
																		</Link>
																	</div>
																	<div class='col-6'>
																		<Link
																			to='javascript:void(0);'
																			data-toggle='tooltip'
																			data-placement='top'
																			title='Share'
																			class='ss-btn'>
																			<i class='far fa-share-square'></i>
																		</Link>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div class='line-c'>
														<div class='row justify-content-between'>
															<div class='col-auto'>
																<span>KD 71,000</span>
															</div>
															<div class='col-auto'>1000 KM</div>
														</div>
													</div>
												</div>
											</div>
										);
								  })
								: ''}
											</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
